import { useContext, useEffect } from "react";
import { ScrollerContext, prefersReducedMotion } from "../RoyalMahal/hooks";

/*
 * Tap anywhere on the invitation and a little shower of marigold and rose petals
 * bursts from that spot. Taps on links, buttons and the RSVP form are left alone.
 * Built with plain DOM nodes that remove themselves, so it never re-renders the page.
 */

const COLORS = ["#ec7a0c", "#f79a17", "#ffcd2e", "#d81b60", "#f06292"];
const IGNORE = "a, button, input, select, textarea, label, iframe, [role='button'], .ut-form, .smothscroll";
const COUNT = 12;

/** A shower of petals from (x, y) in viewport pixels, added to `host` (the theme's root). */
export const burst = (host, x, y) => {
  const group = document.createElement("div");
  group.className = "ut-burst";
  group.style.left = `${x}px`;
  group.style.top = `${y}px`;
  for (let i = 0; i < COUNT; i += 1) {
    const angle = (i / COUNT) * Math.PI * 2 + Math.random() * 0.5;
    const distance = 46 + Math.random() * 44;
    const petal = document.createElement("span");
    petal.style.setProperty("--dx", `${Math.cos(angle) * distance}px`);
    petal.style.setProperty("--dy", `${Math.sin(angle) * distance - 10}px`);
    petal.style.setProperty("--rot", `${Math.round(Math.random() * 540 - 270)}deg`);
    petal.style.background = COLORS[i % COLORS.length];
    group.appendChild(petal);
  }
  host.appendChild(group);
  setTimeout(() => group.remove(), 1200);
};

const PetalBurst = () => {
  const scrollerRef = useContext(ScrollerContext);

  useEffect(() => {
    const host = scrollerRef.current;
    if (!host || prefersReducedMotion()) return undefined;
    const onClick = (event) => {
      if (event.target.closest(IGNORE)) return;
      burst(host, event.clientX, event.clientY);
    };
    host.addEventListener("click", onClick);
    return () => host.removeEventListener("click", onClick);
  }, [scrollerRef]);

  return null;
};

export default PetalBurst;
